<template>
  <div>
    <div class="d-flex justify-content-between mb-3 m-4">
      <div class="flex-grow-2 mr-3">
        <h4 class="font-weight-normal mb-2 pt-1">
          {{ $t('home.blockAudience.graph.title') }}
        </h4>
        <span class="text-gray-600">
          {{ $t('home.blockAudience.graph.subtitle') }}
        </span>
      </div>
      <div class="flex-grow-1 d-flex flex-row align-items-center">
        <CButton
          @click="setChartVisualization(chartVisualizationTypesData.months)"
          class="h-50 mr-2"
          color="purple-200"
          :variant="getBtnVariantFromVisualization(chartVisualizationTypesData.months)"
        >
          {{ $t('home.blockAudience.graph.month') }}
        </CButton>
        <CButton
          @click="setChartVisualization(chartVisualizationTypesData.weeks)"
          class="h-50 mr-2"
          :variant="getBtnVariantFromVisualization(chartVisualizationTypesData.weeks)"
          color="purple-200"
        >
          {{ $t('home.blockAudience.graph.week') }}
        </CButton>
        <CButton
          @click="setChartVisualization(chartVisualizationTypesData.days)"
          class="h-50"
          :variant="getBtnVariantFromVisualization(chartVisualizationTypesData.days)"
          color="purple-200"
        >
          {{ $t('home.blockAudience.graph.day') }}
        </CButton>
      </div>
    </div>
    <CChartLine
      class="p-2"
      style="height: 300px"
      :responsive="false"
      :datasets="[
        {
          data: chartData.datasetData,
          backgroundColor: computedStyle.getPropertyValue('--secondary'),
          label: $t('home.blockAudience.graph.legend'),
          borderColor: computedStyle.getPropertyValue('--primary'),
          fill: false,
          pointer: false,
        },
      ]"
      :labels="chartData.labelsData"
      :options="chartConfig"
    />
  </div>
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { chartVisualizationTypes, getGroupedChartData } from './useAudienceChart'

export default {
  name: 'audienceChart',
  components: { CChartLine },
  props: {
    dailyCount: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartConfig: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                // Remove casas decimais dos valores no eixo Y
                userCallback: function (label) {
                  if (Math.floor(label) === label) {
                    return label
                  }
                },
              },
            },
          ],
        },
      },
      chartVisualizationTypesData: chartVisualizationTypes,
      chartVisualization: chartVisualizationTypes.months,
    }
  },
  computed: {
    computedStyle() {
      return getComputedStyle(document.body)
    },
    chartData() {
      return getGroupedChartData(this.dailyCount, this.chartVisualization)
    },
  },
  methods: {
    getBtnVariantFromVisualization(visualizationType) {
      return visualizationType === this.chartVisualization ? '' : 'outline'
    },
    setChartVisualization(visualizationType) {
      this.chartVisualization = visualizationType
    },
  },
}
</script>
